import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  USER_UPDATE_PRODUCT_SUBSCRIPTION_BEGIN,
  USER_UPDATE_PRODUCT_SUBSCRIPTION_SUCCESS,
  USER_UPDATE_PRODUCT_SUBSCRIPTION_FAILURE,
  USER_UPDATE_PRODUCT_SUBSCRIPTION_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import config from '../../../common/config';
import { createAxiosConfigWithAuth } from '../../../common/apiHelpers';

export function updateProductSubscription(args = {}) {
  return (dispatch, getState) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: USER_UPDATE_PRODUCT_SUBSCRIPTION_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${config.apiRootUrl}/subscriptions/update-product-subscription/${args.id}`,
        args,
        createAxiosConfigWithAuth(getState()),
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: USER_UPDATE_PRODUCT_SUBSCRIPTION_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: USER_UPDATE_PRODUCT_SUBSCRIPTION_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUpdateProductSubscriptionError() {
  return {
    type: USER_UPDATE_PRODUCT_SUBSCRIPTION_DISMISS_ERROR,
  };
}

export function useUpdateProductSubscription() {
  const dispatch = useDispatch();

  const { updateProductSubscriptionPending, updateProductSubscriptionError } =
    useSelector(
      (state) => ({
        updateProductSubscriptionPending:
          state.user.updateProductSubscriptionPending,
        updateProductSubscriptionError:
          state.user.updateProductSubscriptionError,
      }),
      shallowEqual,
    );

  const boundAction = useCallback(
    (...args) => {
      return dispatch(updateProductSubscription(...args));
    },
    [dispatch],
  );

  const boundDismissError = useCallback(() => {
    return dispatch(dismissUpdateProductSubscriptionError());
  }, [dispatch]);

  return {
    updateProductSubscription: boundAction,
    updateProductSubscriptionPending,
    updateProductSubscriptionError,
    dismissUpdateProductSubscriptionError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case USER_UPDATE_PRODUCT_SUBSCRIPTION_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        updateProductSubscriptionPending: true,
        updateProductSubscriptionError: null,
      };

    case USER_UPDATE_PRODUCT_SUBSCRIPTION_SUCCESS:
      // The request is success
      return {
        ...state,
        updateProductSubscriptionPending: false,
        updateProductSubscriptionError: null,
      };

    case USER_UPDATE_PRODUCT_SUBSCRIPTION_FAILURE:
      // The request is failed
      return {
        ...state,
        updateProductSubscriptionPending: false,
        updateProductSubscriptionError: action.data.error,
      };

    case USER_UPDATE_PRODUCT_SUBSCRIPTION_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        updateProductSubscriptionError: null,
      };

    default:
      return state;
  }
}
